<template lang="pug">
.list
  event-list2(:activeCard="id")
  
</template>
<script>
import EventList2 from '@/components/events/EventList2'
export default {
  name: 'List',
  components: { EventList2 },
  props: ['id'],
  data() {
    return {}
  },
  computed: {},
  methods: {},
  mounted() {},
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.list
  position: absolute
  top: 0
  left: 0
  width: 100%
  height: 100%
</style>
